import React,{useState,useEffect} from 'react'
import EcxDatatable from '../common/datatable/EcxDatatable'
import {useNavigate} from 'react-router-dom'
import surveyService from '../../services/survey.service'
import {toast} from 'react-toastify'
import { useEyeconxStore } from '../../store/eyeconxStore'
function SurveyTable() {
     
    const navigate = useNavigate()
    const [surveyList,setSurveyList] = useState([])
    const adminClinicId = useEyeconxStore((state)=>state.user.clinicId)
    useEffect(()=>{

        getAllSurveys()
    },[])

    const getAllSurveys  = ()=>{
        surveyService.getAllEcxSurveys(adminClinicId)
        .then(res=>{
            setSurveyList(res.data)
        })
        .catch(err=>{
            console.log(err)
        })
    }
    const columns = [
        {name:'Id',selector:row=>row.id,sortable:true},
        {name:'Title',selector:row=>row.title,sortable:true},
        {name:'Description',selector:row=>row.description,sortable:true},
        {name:'Options',
            selector:row=>{
                return(<>
                    <div><button className="btn btn-primary" onClick={()=>handleClick(row.id)}><i className="bi bi-pencil"></i></button></div>
                </>)
            }
        }
    ]

    const handleClick = (id)=>{
        navigate('edit/'+id)
    }
    return (
   <>
   <div className="p-3">

  
       <EcxDatatable
                                            columns={columns}
                                            data={surveyList}
                                            pagination={true}
                                            paginationPerPage={5}
                                            paginationRowsPerPageOptions={[5, 10, 15]}
                                            highlightOnHover
                                            striped
                                          
                                        />
     </div>
   </>
  )
}

export default SurveyTable